import styles from './Avatar.module.css';

type AvatarProps = {
  /** Single character, or 2 for initials. */
  initial: string;
  /** Diameter in pixels. Default 32. */
  size?: number;
  /** Override bg — accepts any CSS color, including var(--c-training). Default --signal marine. */
  bg?: string;
  fg?: string;
  className?: string;
  /** Ariatitle for screen readers — default hidden since avatar is decorative next to the name. */
  title?: string;
};

/**
 * Circular initial avatar. Used for "me" chips (sidenav, top bar),
 * team-feed kudos, and coach glyphs (tf-story-glyph in mobile mockup
 * is a rounded square rather than a circle — that's a separate variant
 * we'll add if needed, not baked into this primitive).
 *
 * Per palette-ink-marine.css the default Ramiro avatar is --signal
 * (marine) with white text. Team member avatars use coach-colored bgs
 * via the `bg` prop.
 */
export function Avatar({
  initial,
  size = 32,
  bg,
  fg,
  className,
  title,
}: AvatarProps) {
  return (
    <span
      className={[styles.avatar, className].filter(Boolean).join(' ')}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.4)),
        ...(bg ? { background: bg } : {}),
        ...(fg ? { color: fg } : {}),
      }}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {initial}
    </span>
  );
}
